import { createSlice } from '@reduxjs/toolkit';

export interface DevelopmentSchedule {
  businessPlanFinalized: string;
  listingAgentAgreement: string;
  constructionContractExecuted: string;
}

const initialState: DevelopmentSchedule = {
  businessPlanFinalized: '',
  listingAgentAgreement: '',
  constructionContractExecuted: '',
};

export const DevelopmentScheduleSlice = createSlice({
  name: 'developmentScheduleSliceInfo',
  initialState,
  reducers: {
    setDevelopmentSchedule(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
});

export const { setDevelopmentSchedule } = DevelopmentScheduleSlice.actions;

export default DevelopmentScheduleSlice.reducer;
